import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl95 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Command_95",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Free_Text",
			className: "black",
			d: "M46.47,13c.56,0,1.1.21,1.5.63l2.3,2.28c.45.47.73,1.06.73,1.69,0,.56-.21,1.15-.73,1.67l-11.74,11.76c-.28.28-.63.54-.96.59l-5.31,1.34c-.07.02-.14.02-.23.02-.28,0-.54-.12-.7-.31-.21-.21-.38-.52-.31-.8l.02-.12,1.27-5.12c.09-.4.28-.75.54-1.03l11.88-11.88c.47-.47,1.1-.73,1.74-.73ZM34.4,26.83l-.07.07s-.05.12-.07.21l-.87,3.48,3.43-.82s.19-.05.23-.09l.09-.09-2.75-2.75ZM43.42,17.88l-7.56,7.56,2.7,2.72,7.58-7.58-2.72-2.7ZM46.4,15.04c-.09,0-.19.02-.26.12l-1.32,1.32,2.75,2.75,1.32-1.34c.07-.07.09-.14.09-.23s-.05-.21-.14-.31l-2.18-2.18c-.07-.09-.16-.12-.26-.12ZM57,35.17v-6.36c0-1.55-1.25-2.82-2.78-2.82h-8.22c-.55,0-1,.45-1,1s.45,1,1,1h8.22c.43,0,.78.37.78.82v6.36c0,.45-.35.82-.78.82H9.78c-.43,0-.78-.37-.78-.82v-6.36c0-.45.35-.82.78-.82h19.22c.55,0,1-.45,1-1s-.45-1-1-1H9.78c-1.53,0-2.78,1.26-2.78,2.82v6.36c0,1.55,1.25,2.82,2.78,2.82h44.45c1.53,0,2.78-1.26,2.78-2.82Z"
		})
	})]
});
export default SvgAppIcBefehl95;
